import {
    InterruptionModel,
    InterruptionsListModel,
} from '../models/interruptions/interruptionList.model';
import { getDatesBetweenDates } from './handlerDates';

/**
 * Obtenemos un listado de interrupciones basada en un rango de fechas
 * @param startDate string
 * @param endDate string
 * @param employeeID string | number
 * @param interruptionList InterruptionsListModel
 * @returns InterruptionModel[]
 */
export const getInterruptionsListBetweenDates = (
    startDate: string,
    endDate: string,
    employeeID: string | number,
    interruptionList: InterruptionsListModel
) => {
    if (interruptionList.interruptionsList) {
        const records = interruptionList.interruptionsList.filter((emp) => {
            return emp.employeeId === employeeID;
        });

        let dates = getDatesBetweenDates(startDate, endDate);

        const result = records.filter((interr) =>
            dates.includes(interr.startDate.split('T')[0])
        );

        return result;
    }
    return [];
};

/**
 * Obtenemos un listado de interrupciones basado en la fecha y en el empleado
 * @param date string | number
 * @param employeeID string | number
 * @param interruptionList InterruptionsListModel
 * @returns InterruptionModel[]
 */
export const getInterruptionListByDate = (
    date: string | number,
    employeeID: string | number,
    interruptionList: InterruptionsListModel
) => {
    if (interruptionList.interruptionsList) {
        const records = interruptionList.interruptionsList.filter((emp) => {
            return (
                emp.employeeId === employeeID && emp.startDate.split('T')[0] === date
            );
        });

        return records;
    }
    return [];
};

/**
 * Obtener la primera interrupción en base en la fecha
 * @param interruptions InterruptionModel[] | undefined
 * @param date string
 * @returns InterruptionModel | undefined
 */
export const getFirstInterruption = (
    interruptions: InterruptionModel[] | undefined,
    date: string
) => {
    return interruptions?.find((i) => i.startDate.split('T')[0] == date);
};
